module.exports = __webpack_public_path__ + "static/media/wechat.130c82e8.png";